<template>
  <div>
    <div class="header pt-1 pt-md-8">
      <div class="container-fluid">

        <div class="divisor">{{ $t('ofertas') }}</div>

        <b-row class="align-items-end mt-3 mb-4">
          <b-col md="9">
            <span class="text-muted" v-if="ofertas.length">{{ ofertas.length }} {{ $t('resultado_ofertas') }}</span>
          </b-col>
          <b-col md="3" class="text-right">
            <b-button variant="primary" size="sm" @click="cargarOfertas" :disabled="cargando">
              <b-spinner small v-if="cargando" class="mr-1" />
              {{ $t('actualizar') }}
            </b-button>
          </b-col>
        </b-row>

        <b-alert variant="danger" :show="!!error" dismissible @dismissed="error = ''">
          {{ error }}
        </b-alert>

        <div v-if="cargando" class="text-center text-muted mt-5">
          <b-spinner variant="primary" />
        </div>

        <div v-else-if="ofertas.length" class="card shadow">
          <div class="table-responsive">
            <table class="table table-hover align-items-center mb-0">
              <thead class="thead-light">
                <tr>
                  <th @click="ordenarPor('id')" class="th-ordenable">ID {{ obtenerIconoOrden('id') }}</th>
                  <th @click="ordenarPor('nombre')" class="th-ordenable">{{ $t('nombre') }} {{ obtenerIconoOrden('nombre') }}</th>
                  <th @click="ordenarPor('email')" class="th-ordenable">{{ $t('correo') }} {{ obtenerIconoOrden('email') }}</th>
                  <th>{{ $t('fono') }}</th>
                  <th>{{ $t('oferta_label') }}</th>
                  <th @click="ordenarPor('estado')" class="th-ordenable text-center">{{ $t('estado') }} {{ obtenerIconoOrden('estado') }}</th>
                  <th @click="ordenarPor('fechaRegistro')" class="th-ordenable">{{ $t('fecha') }} {{ obtenerIconoOrden('fechaRegistro') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="o in ofertasOrdenadas" :key="o.id">
                  <td>{{ o.id }}</td>
                  <td>{{ o.nombre }}</td>
                  <td>{{ o.email }}</td>
                  <td>{{ o.fono || '-' }}</td>
                  <td>{{ o.oferta ? (o.oferta.length > 60 ? o.oferta.substring(0, 60) + '…' : o.oferta) : '-' }}</td>
                  <td class="text-center">
                    <span :class="badgeClass(o.estado)">{{ labelEstado(o.estado) }}</span>
                  </td>
                  <td>{{ formatFecha(o.fechaRegistro) }}</td>
                  <td class="text-center">
                    <b-button size="sm" variant="outline-primary" @click="abrirDetalle(o)">{{ $t('ver_detalle') }}</b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-else-if="!cargando" class="text-center text-muted mt-5">
          <i class="fas fa-inbox fa-3x mb-3"></i>
          <p>{{ $t('sin_ofertas') }}</p>
        </div>

      </div>
    </div>

    <b-modal v-model="modalVisible" :title="$t('detalle_oferta')" size="lg" hide-footer>
      <div v-if="ofertaSeleccionada" class="detalle-modal">
        <div class="row">
          <div class="col-md-6">
            <div class="detalle-item">
              <span class="detalle-label">ID</span>
              <span class="detalle-valor">{{ ofertaSeleccionada.id }}</span>
            </div>
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('nombre') }}</span>
              <span class="detalle-valor">{{ ofertaSeleccionada.nombre }}</span>
            </div>
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('correo') }}</span>
              <span class="detalle-valor">{{ ofertaSeleccionada.email }}</span>
            </div>
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('fono') }}</span>
              <span class="detalle-valor">{{ ofertaSeleccionada.fono || '-' }}</span>
            </div>
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('fecha_registro') }}</span>
              <span class="detalle-valor">{{ formatFecha(ofertaSeleccionada.fechaRegistro) }}</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('oferta_label') }}</span>
              <span class="detalle-valor">{{ ofertaSeleccionada.oferta || '-' }}</span>
            </div>
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('mensaje') }}</span>
              <span class="detalle-valor">{{ ofertaSeleccionada.mensaje || '-' }}</span>
            </div>
          </div>
        </div>

        <hr class="my-3" />

        <div class="row">
          <div class="col-md-4">
            <label class="form-label">{{ $t('estado') }}</label>
            <b-form-select v-model="formEdicion.estado" :options="opcionesEstado" />
          </div>
          <div class="col-md-8">
            <label class="form-label">{{ $t('observacion_interna') }}</label>
            <b-form-textarea
              v-model="formEdicion.observacionInterna"
              rows="2"
              :placeholder="$t('agregar_observacion')"
            />
          </div>
        </div>

        <div class="text-right mt-3">
          <b-button variant="secondary" class="mr-2" @click="modalVisible = false">{{ $t('cancelar') }}</b-button>
          <b-button variant="primary" @click="guardarCambios" :disabled="guardando">
            <b-spinner small v-if="guardando" class="mr-1" />
            {{ $t('guardar') }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ofertaWebService from '@/api/ofertaWebService';

export default {
  name: 'OfertasView',

  data() {
    return {
      ofertas: [],
      cargando: false,
      error: '',
      ordenColumna: null,
      ordenDireccion: 'asc',
      modalVisible: false,
      ofertaSeleccionada: null,
      guardando: false,
      formEdicion: {
        estado: 'P',
        observacionInterna: '',
      },
    };
  },

  mounted() {
    this.cargarOfertas();
  },

  computed: {
    opcionesEstado() {
      return [
        { value: 'P', text: this.$t('estado_pendiente') },
        { value: 'G', text: this.$t('estado_en_gestion') },
        { value: 'R', text: this.$t('estado_respondida') },
        { value: 'C', text: this.$t('estado_cerrada') },
      ];
    },
    ofertasOrdenadas() {
      if (!this.ordenColumna) return this.ofertas;
      const lista = [...this.ofertas];
      lista.sort((a, b) => {
        let vA = a[this.ordenColumna];
        let vB = b[this.ordenColumna];
        if (vA == null) vA = '';
        if (vB == null) vB = '';
        if (typeof vA === 'number' && typeof vB === 'number') {
          return this.ordenDireccion === 'asc' ? vA - vB : vB - vA;
        }
        vA = String(vA).toLowerCase();
        vB = String(vB).toLowerCase();
        if (vA < vB) return this.ordenDireccion === 'asc' ? -1 : 1;
        if (vA > vB) return this.ordenDireccion === 'asc' ? 1 : -1;
        return 0;
      });
      return lista;
    },
  },

  methods: {
    async cargarOfertas() {
      this.cargando = true;
      this.error = '';
      try {
        this.ofertas = await ofertaWebService.getAll();
      } catch (e) {
        this.error = (e && e.response && e.response.data && e.response.data.message) || this.$t('error');
      } finally {
        this.cargando = false;
      }
    },

    abrirDetalle(oferta) {
      this.ofertaSeleccionada = oferta;
      this.formEdicion.estado = oferta.estado || 'P';
      this.formEdicion.observacionInterna = oferta.observacionInterna || '';
      this.modalVisible = true;
    },

    async guardarCambios() {
      this.guardando = true;
      try {
        await ofertaWebService.update(this.ofertaSeleccionada.id, {
          estado: this.formEdicion.estado,
          observacionInterna: this.formEdicion.observacionInterna,
        });
        const idx = this.ofertas.findIndex(o => o.id === this.ofertaSeleccionada.id);
        if (idx !== -1) {
          this.$set(this.ofertas, idx, {
            ...this.ofertas[idx],
            estado: this.formEdicion.estado,
            observacionInterna: this.formEdicion.observacionInterna,
          });
        }
        this.modalVisible = false;
      } catch (e) {
        this.error = (e && e.response && e.response.data && e.response.data.message) || this.$t('error_guardar');
      } finally {
        this.guardando = false;
      }
    },

    ordenarPor(columna) {
      if (this.ordenColumna === columna) {
        this.ordenDireccion = this.ordenDireccion === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumna = columna;
        this.ordenDireccion = 'asc';
      }
    },

    obtenerIconoOrden(columna) {
      if (this.ordenColumna !== columna) return '↕️';
      return this.ordenDireccion === 'asc' ? '↑' : '↓';
    },

    formatFecha(fecha) {
      if (!fecha) return '-';
      return new Date(fecha).toLocaleDateString('es-CL');
    },

    labelEstado(estado) {
      const map = {
        P: this.$t('estado_pendiente'),
        G: this.$t('estado_en_gestion'),
        R: this.$t('estado_respondida'),
        C: this.$t('estado_cerrada'),
      };
      return map[estado] || estado;
    },

    badgeClass(estado) {
      const map = {
        P: 'badge badge-pill badge-warning',
        G: 'badge badge-pill badge-info',
        R: 'badge badge-pill badge-success',
        C: 'badge badge-pill badge-secondary',
      };
      return map[estado] || 'badge badge-pill badge-light';
    },
  },
};
</script>

<style scoped>
.divisor {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  padding: 15px;
  background: #6172e9;
  border-radius: 10px;
}
.form-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #525f7f;
  margin-bottom: 4px;
  display: block;
}
.card {
  border-radius: 10px;
  overflow: hidden;
}
.th-ordenable {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}
.th-ordenable:hover {
  background-color: #e9ecef !important;
}
.th-ordenable:active {
  background-color: #dee2e6 !important;
}
.detalle-modal {
  padding: 8px 0;
}
.detalle-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.detalle-item:last-child {
  border-bottom: none;
}
.detalle-label {
  font-weight: 600;
  color: #525f7f;
  font-size: 0.85rem;
  flex: 0 0 45%;
}
.detalle-valor {
  color: #32325d;
  font-size: 0.9rem;
  text-align: right;
  flex: 1;
}
</style>
